"use client";
import { useEffect, useState } from "react";

import { useFlags } from "@stadium/services/launch-darkly";
import { useFeatureFlag } from "@stadium/services/launch-darkly/use-feature-flag";
import { quickRecogniseWidgetFlag } from "@stadium/services/launch-darkly/constants";

const useWidget = () => {
  const { isReady } = useFeatureFlag();
  const { [quickRecogniseWidgetFlag]: isQuickRecogniseWidgetEnabled } = useFlags();
  const [stadiumWidgets, setStadiumWidgets] = useState(null);

  useEffect(() => {
    const initWidget = async () => {
      // eslint-disable-next-line import/no-unresolved
      setStadiumWidgets(await import("@stadium/widgets"));
    };
    if (isReady && isQuickRecogniseWidgetEnabled) {
      initWidget();
    }
  }, [isReady, isQuickRecogniseWidgetEnabled]);

  return { widgets: stadiumWidgets };
};

export default useWidget;
